import request from 'request';
import { API_NODE, URL_BACKEND, API_TOKEN, GATEWAY_API_KEY } from './config';

export const getPedidosConfirmados = (token, filters) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: API_TOKEN,
          'x-api-key': GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': '17e62166fc8586dfa4d1bc0e1742c08b'
        },
        uri: `${API_NODE}/orders`,
        method: 'GET',
        qs: filters
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

export const getPedidosRespondidos = (token, filters) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: API_TOKEN,
          'x-api-key': GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': 'f7177163c833dff4b38fc8d2872f1ec6'
        },
        uri: `${API_NODE}/orders`,
        method: 'GET',
        qs: filters
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

export const getPedidosAgendados = (token, filters) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: API_TOKEN,
          'x-api-key': GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': 'a1d0c6e83f027327d8461063f4ac58a6'
        },
        uri: `${API_NODE}/orders/findOrdersByScheduleStatus`,
        method: 'GET',
        qs: filters
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

export const getItensPedidoRespondido = (token, filters) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: URL_BACKEND + '/gerenciarPedidos/itensPedidos',
        method: 'GET',
        qs: filters
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

export const getMotivoDaRecusa = (token, filters) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: URL_BACKEND + '/gerenciarPedidos/motivos',
        method: 'GET',
        qs: filters
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};
